import api from '../../../helpers/api';

export const signTermsOfUse = (version: { version: string }) =>
  api.post('/developer/platform/manager/terms_of_use', version);
